Lang_en_en = {
    lang: 'Languaje',
    es_es: 'Spanish',
    en_en: 'English',
    Hello: 'Hello',
    Ibero: 'Campus IberoAmericana University',
    Info: 'information',
    User: 'User',
    NameUser: 'User Name',
    Password: 'Password',
    Login: 'Login',
    AlertSecury: 'Security Alert',
    MsgAlertSecury: 'The username or password you entered is not valid, please try again.',

    txtIberoPresen: 'Recursos en línea para todos nuestros estudiantes Ibero',
    txtIberoVitual: 'Recursos para nuestros estudiantes virtuales Ibero',
    txtIberoCampus: '',

    /*Menu*/
    Exit: 'LogOut',
    Users: 'User',
    Account: 'Account',
    Settings: 'Settings',
    Update: 'Update',

    Accepted: 'Accepted',
    NotAccepted: 'Not accepted'    
}